<template>
  <div class="app-container">
    <!-- 顶部标题区 -->
    <header class="header">
      <div class="header-content">
        <h1 class="main-title">八大成就论</h1>
        <p class="subtitle">大正修订大藏经779</p>
      </div>
    </header>

    <!-- 主要内容区 -->
    <main class="content">
      <!-- 引言部分 -->
      <section class="intro">
        <p class="intro-text">
          觉悟者的弟子们应当日夜全心全意地诵念和禅修大圣们所发现的八种证悟。
        </p>
      </section>

      <!-- 八大觉悟卡片列表 -->
      <section class="insights-list">
        <!-- 第一觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第一觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到世界是无常的。政治体制终将覆灭。由四元素构成的万物皆空，其中蕴含着苦的种子。人类由五蕴构成，无我。他们始终处于变化之中——不断生老病死。他们空无自我，无独立存在。心是所有迷惑的根源，身是所有不善业的森林。禅修此理，便可从生死轮回中解脱。
            </p>
          </div>
        </div>

        <!-- 第二觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第二觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到欲望越多，痛苦越多。日常生活中的一切苦难都源于贪婪和欲望。那些欲望和野心较少的人能够放松身心，摆脱束缚。
            </p>
          </div>
        </div>

        <!-- 第三觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第三觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到人的心灵总是向外寻求，却永远无法感到满足。这会导致不善的行为。而菩萨则深知少欲的价值。他们生活简朴平和，以便专心修行佛法。他们将证得圆满觉悟视为毕生追求。
            </p>
          </div>
        </div>

        <!-- 第四觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第四觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到懒惰是练习的障碍。你必须勤奋修行，才能转化束缚你的不善心念，才能战胜四种魔罗，才能从五蕴和三界的牢笼中解脱出来。
            </p>
          </div>
        </div>

        <!-- 第五觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第五觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到无知是生死轮回的根源。菩萨总是聆听他人、学习他人，以便发展自己的理解力和方便法门，从而教导众生，给他们带来极大的快乐。
            </p>
          </div>
        </div>

        <!-- 第六觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第六觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到贫困滋生仇恨和愤怒，从而形成消极思想和行为的恶性循环。菩萨行布施时，视所有人——无论朋友还是敌人——平等相待。他们不谴责任何人过去的罪行，甚至也不憎恨那些现在正在伤害他人的人。
            </p>
          </div>
        </div>

        <!-- 第七觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第七觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到五种感官欲望——金钱、性、名誉、暴饮暴食和过度睡眠——都会导致问题。身处尘世，切勿执着于世俗之事。例如，一位僧人仅有三件僧袍和一个钵盂，他生活简朴，只为修行佛法。他的戒律使他远离世俗的执着，他平等慈悲地对待每一个人。
            </p>
          </div>
        </div>

        <!-- 第八觉悟 -->
        <div class="insight-card">
          <div class="card-header">
            <h2 class="card-title">第八觉悟</h2>
            <div class="card-divider"></div>
          </div>
          <div class="card-body">
            <p class="card-text">
              意识到生死之火熊熊燃烧，给世间带来无尽的苦难。发愿帮助一切众生，与一切众生一同受苦，引导一切众生进入极乐净土。
            </p>
          </div>
        </div>
      </section>

      <!-- 总结部分 -->
      <section class="conclusion">
        <p class="conclusion-text">
          这八种证悟是伟大众生、佛陀和菩萨精进修习智慧与慈悲之道后所领悟的。他们乘着法身舟抵达涅槃之岸，随后又回归凡间，摆脱了五种欲望，心念一心向往圣道。他们运用这八种证悟，帮助一切众生认识到世间的苦难。
        </p>
        <p class="conclusion-highlight">
          如果佛陀的弟子们念诵并冥想这八种证悟，他们将消除无数的误解和困难，并朝着觉悟的方向前进，离开生死轮回，永远安住于和平之中。
        </p>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-content">
        <p class="footer-text">八大成就论 · 大正修订大藏经779</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
// Vue3 组合式API，无额外逻辑
</script>

<style scoped>
/* 全局CSS变量 */
:root {
  --primary-color: #8c7c6e;
  --secondary-color: #a6988b;
  --bg-color: #f9f7f5;
  --card-bg: #ffffff;
  --text-primary: #333333;
  --text-secondary: #555555;
  --text-light: #777777;
  --border-color: #e8e4e0;
  --shadow-light: 0 2px 8px rgba(0, 0, 0, 0.05);
  --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.1);
  --transition-default: all 0.3s ease;
}

/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  font-family: "Noto Serif SC", "SimSun", "Microsoft YaHei", serif;
  background-color: var(--bg-color);
  color: var(--text-primary);
  line-height: 1.8;
}

/* 容器样式 */
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 头部样式 */
.header {
  padding: 2.5rem 0;
  border-bottom: 1px solid var(--border-color);
  text-align: center;
}

.header-content {
  max-width: 800px;
  margin: 0 auto;
}

.main-title {
  font-size: 2.2rem;
  font-weight: 400;
  color: var(--primary-color);
  margin-bottom: 0.8rem;
  letter-spacing: 0.1rem;
}

.subtitle {
  font-size: 1rem;
  color: var(--text-light);
  font-style: italic;
}

/* 内容区域 */
.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  flex: 1;
}

/* 引言样式 */
.intro {
  margin-bottom: 3rem;
  padding: 0 1rem;
}

.intro-text {
  font-size: 1.1rem;
  color: var(--text-secondary);
  font-style: italic;
  text-align: center;
  line-height: 2;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
}

/* 八大觉悟卡片列表 */
.insights-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 3rem;
}

/* 卡片样式 - 核心设计 */
.insight-card {
  background: var(--card-bg);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-light);
  transition: var(--transition-default);
  position: relative;
}

.insight-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  opacity: 0.8;
}

.insight-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-medium);
}

.insight-card:hover::before {
  opacity: 1;
}

/* 卡片头部 */
.card-header {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--border-color);
}

.card-title {
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.card-divider {
  width: 50px;
  height: 2px;
  background-color: var(--secondary-color);
  opacity: 0.6;
}

/* 卡片内容 */
.card-body {
  padding: 2rem;
}

.card-text {
  font-size: 1.05rem;
  color: var(--text-secondary);
  line-height: 1.9;
  text-align: justify;
}

/* 总结部分 */
.conclusion {
  padding: 1rem;
  border-top: 1px solid var(--border-color);
  margin-top: 1rem;
}

.conclusion-text {
  font-size: 1.05rem;
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.9;
}

.conclusion-highlight {
  font-size: 1.1rem;
  color: var(--primary-color);
  font-weight: 500;
  line-height: 1.9;
  padding-left: 0.5rem;
  border-left: 3px solid var(--secondary-color);
}

/* 页脚样式 */
.footer {
  padding: 2rem 0;
  border-top: 1px solid var(--border-color);
  text-align: center;
}

.footer-content {
  max-width: 800px;
  margin: 0 auto;
}

.footer-text {
  font-size: 0.9rem;
  color: var(--text-light);
}

/* 响应式设计 */
@media (max-width: 768px) {
  html {
    font-size: 15px;
  }

  .header {
    padding: 1.5rem 0;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .content {
    padding: 1.5rem 1rem;
  }

  .card-header {
    padding: 1.2rem 1.5rem;
  }

  .card-body {
    padding: 1.5rem;
  }

  .card-title {
    font-size: 1.25rem;
  }

  .intro {
    margin-bottom: 2rem;
  }

  .insights-list {
    gap: 1.5rem;
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.5rem;
  }

  .card-header {
    padding: 1rem 1.2rem;
  }

  .card-body {
    padding: 1.2rem;
  }

  .conclusion-highlight {
    font-size: 1rem;
  }
}
</style>
